import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import questionIcon from '../../assets/svgs/question.svg';
import rankIcon from '../../assets/svgs/rank.svg';
import courseIcon from '../../assets/svgs/course.svg';
import settingIcon from '../../assets/svgs/setting.svg';
import instructionSvg from '../../assets/svgs/instruction.svg';
import arrowSvg from '../../assets/svgs/arrow.svg';
import { ButtonYellow } from '../buttons';
import { useCourse } from '../../pages/course/hooks';

const imageUrl = "https://s3.ap-south-1.amazonaws.com/azvasa-lms-cdn-dev-new/IR-SERVICE/imageUrl/936fbbfb-8103-4f96-b3ce-e084150f20c6_0b70b10e-2397-4587-98ee-f5aaee376aae.jpg"

export const DiagnosticTestInfo2 = ({ onClickCta }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { current } = useCourse();

    const detailsConfig = [
        {
            icon: questionIcon,
            label: 'What is it?',
            value: 'An assessment to determine your current level'
        },
        {
            icon: settingIcon,
            label: 'How does it work?',
            value: 'Questions adapt based on your responses to accurately assess your level'
        },
        {
            icon: rankIcon,
            label: 'Scoring System',
            value: 'Based on performance accuracy',
            chips: [
                { label: 'Higher Score → Advanced Level ', color: 'success' },
                { label: 'Lower Score → Foundation Level', color: 'primary' }
            ]
        },
        {
            icon: courseIcon,
            label: 'Course Assignment',
            value: 'Automatic placement into the right course based on level',
            chips: [
                { label: 'Level 4, 5 (Sparkle) ', color: 'success' },
                { label: 'Level 0,1,2,3 (Ember)', color: 'primary' }
            ]
        }
    ];

    return (
        <Box sx={{
            position: 'relative',
            display: { xs: 'block', sm: 'flex' },
            justifyContent: 'space-between',
            textAlign: 'center',
            background: '#fff',
            p: 2,
            mt: 0,
            borderRadius: 2,
            boxShadow: 10,
            alignItems: 'center',
            borderTop: '2px solid #FF716F',
        }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* <Card>
                <CardContent>
                    {detailsConfig.map((detail, index) => (
                        <Grid key={index} sx={{
                            alignItems: 'center',
                            margin: 1,
                            justifyContent: 'flex-start',
                            flexWrap: 'nowrap', // Prevent wrapping in most cases
                            gap: 1,
                        }} container >
                            <Grid sx={{}} item xs={1}>
                                <img style={{
                                    width: '20px',
                                    maxWidth: '100%',
                                    height: 'auto',
                                }} src={detail.icon} alt="" />
                            </Grid>
                            <Grid sx={{}} item xs={11}>
                                <Typography
                                    sx={{
                                        fontSize: { xs: '0.8em', sm: '1em', md: '1.2em', lg: '1.4em' }, // Smaller on extra small screens
                                        fontWeight: 500,
                                        fontFamily: '"Quicksand", sans-serif',
                                    }}
                                >
                                    {detail.label}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: { xs: '0.8em', sm: '0.8em', md: '1em', lg: '1em' }, // Adjusts size on smaller devices
                                        fontWeight: 700,
                                        fontFamily: '"Quicksand", sans-serif',
                                    }}
                                >
                                    {detail.value}
                                </Typography>
                                {detail?.chips &&
                                    <Typography
                                        sx={{
                                            fontSize: { xs: '0.8em', sm: '0.8em', md: '1em', lg: '1em' }, // Smaller on extra small screens
                                            fontWeight: 500,
                                            fontFamily: '"Quicksand", sans-serif',
                                        }}
                                    >
                                        {detail?.chips.map((chip) => {
                                            return chip?.label
                                        })}
                                    </Typography>
                                }
                            </Grid>
                        </Grid>
                    ))}
                </CardContent>
            </Card> */}
            {/* <Box
                sx={{
                    width: { xs: '15%', sm: '10%' }, // Adjusts width based on screen size
                    left: '50%',
                    transform: 'translateX(-50%)',
                    position: 'absolute',
                    top: '-20px',
                    border: '1px solid #fff',
                    borderRadius: '50%',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Box
                    sx={{
                        background: '#fff',
                        borderRadius: '50%',
                        padding: '10px 0px',
                        margin: '3px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    <img style={{
                        width: '70%',
                        maxWidth: '100%',
                        height: 'auto',
                    }} src={instructionSvg} alt="" />
                </Box>
            </Box> */}
            {/* <Box sx={{
                position: 'relative',
                display: { xs: 'block', sm: 'flex' },
                justifyContent: 'space-between',
                textAlign: 'center',
                background: '#fff',
                p: 2,
                mt: 2,
                borderRadius: 2,
                boxShadow: 10,
                alignItems: 'center',
                borderTop: '2px solid #FF716F',
            }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            > */}
            <Box sx={{
                overflow: 'hidden',
                borderRadius: 2,
                '& img': {

                },
                '& img': {
                    transition: isHovered ? 'transform 0.3s ease-in-out' : '',
                    transform: isHovered ? 'scale(1.1) rotate(3deg)' : '', // Slight zoom-in and rotation
                },
                cursor: 'pointer'
            }}>
                <img style={{ borderRadius: 10 }} height={"150"} src={current?.imageUrl} alt="" />
            </Box>
            <Box sx={{ p: 2, position: 'relative' }}>
                <Typography sx={{
                    fontSize: { xs: '1.2em', lg: '1.4em', xl: '1.6em' }, fontFamily: '"Quicksand", sans-serif', color: '#000',
                    fontWeight: 700,
                }}>
                    {current?.courseName}
                </Typography>

            </Box>

            <ButtonYellow sx={{
                left: '50%',
                transform: 'translateX(-50%)',
                position: 'absolute',
                bottom: '-20px',
                mt: 2
            }}
                onClick={onClickCta}>
                <Typography
                    sx={{
                        fontWeight: '700',
                        fontFamily: '"Quicksand", sans-serif',
                        fontSize: { xs: '0.8em', md: '1em', lg: '1em', xl: '1em' },
                        zIndex: 2, // Ensure the text is above the glossy effect
                    }}
                >
                    Diagnostic Test!
                </Typography>
                <img
                    style={{
                        width: '15%',
                        maxWidth: '100%',
                        marginTop: '5px',
                        height: 'auto',
                        zIndex: 2, // Ensure the image is above the glossy effect
                    }}
                    src={arrowSvg}
                    alt=""
                />
            </ButtonYellow>
        </Box>

    );
};